/**
 * The CX dashboard is in limited rollout while the ticket risk scoring model is being
 * validated, so access is restricted to the CX and engineering folks reviewing it rather
 * than every employee. Unlike `canAccessLab` this applies in every environment — the
 * point is to keep the in-progress scores off the wider team's screens everywhere.
 *
 * This gate hides the UI; it is not a security boundary. The underlying svc-support
 * endpoint authorises on the `admin-user` / `employee` roles, so anyone with those roles
 * can still call the API directly. Narrow the endpoint too if that matters.
 */
export const CX_DASHBOARD_ALLOWED_EMAILS: ReadonlyArray<string> = [
  'james.beattie@luxuryescapes.com',
  'sharon.maprasert@luxuryescapes.com',
  'min.pangastur@luxuryescapes.com',
  'emily.gibney@luxuryescapes.com',
  'koren.sela@luxuryescapes.com',
  'william.ritossa@luxuryescapes.com',
  'kristine.lane@luxuryescapes.com',
  'lachlan.mellington@luxuryescapes.com',
  'shay.hamama@luxuryescapes.com',
  'vanessa.kraut@luxuryescapes.com',
];

const allowedEmails = new Set(CX_DASHBOARD_ALLOWED_EMAILS.map((email) => email.toLowerCase()));

export function canAccessCxDashboard(user: { email?: string | null } | null | undefined): boolean {
  if (!user?.email) {
    return false;
  }

  return allowedEmails.has(user.email.trim().toLowerCase());
}
